import actions from '@/core/store/processo/actions'
import mutations from '@/core/store/processo/mutations'
import state from '@/core/store/processo/state'

export default { actions, mutations, state }
